// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__20KzN","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3U0Zi","obliqueLine":"membershipbadge_obliqueLine__1dOXo"};